export const PERMISSIONS = {
  ACTIVATE_PLANNER: 'activate_planner',
  DELETE_LOOP: 'delete_loop',
  EDIT_AGENTIC_DIAL: 'edit_agentic_dial',
  EDIT_BILLING: 'edit_billing',
  EDIT_CAPACITY: 'edit_capacity',
  EDIT_DEMAND: 'edit_demand',
  EDIT_FINANCE: 'edit_finance',
  EDIT_GOVERNANCE: 'edit_governance',
  EDIT_INSIGHTS: 'edit_insights',
  EDIT_INSIGHT_TRACKING: 'edit_insight_tracking',
  EDIT_INTEGRATIONS: 'edit_integrations',
  EDIT_ITEMS: 'edit_items',
  EDIT_ITEM_STORE_CONFIG: 'edit_item_store_config',
  EDIT_LOOP: 'edit_loop',
  EDIT_LOOP_VISUALIZATION: 'edit_loop_visualization',
  EDIT_OBJECTIVES: 'edit_objectives',
  EDIT_ORGANIZATION: 'edit_organization',
  EDIT_PLANNER: 'edit_planner',
  EDIT_RECOMMENDATIONS: 'edit_recommendations',
  EDIT_WORKER_TYPE: 'edit_worker_type',
  EVALUATE_DEMAND: 'evaluate_demand',
  SYNC_INTEGRATIONS: 'sync_integrations',
  VIEW_AGENTIC_DIAL: 'view_agentic_dial',
  VIEW_AUDIT_LOG: 'view_audit_log',
  VIEW_BILLING: 'view_billing',
  VIEW_CAPACITY: 'view_capacity',
  VIEW_DEMAND: 'view_demand',
  VIEW_FINANCE: 'view_finance',
  VIEW_GOVERNANCE: 'view_governance',
  VIEW_INSIGHTS: 'view_insights',
  VIEW_INSIGHT_TRACKING: 'view_insight_tracking',
  VIEW_INTEGRATIONS: 'view_integrations',
  VIEW_ITEMS: 'view_items',
  VIEW_ITEM_STORE_CONFIG: 'view_item_store_config',
  VIEW_LOOP: 'view_loop',
  VIEW_LOOP_VISUALIZATION: 'view_loop_visualization',
  VIEW_OBJECTIVES: 'view_objectives',
  VIEW_ORGANIZATION: 'view_organization',
  VIEW_PLANNER: 'view_planner',
  VIEW_RECOMMENDATIONS: 'view_recommendations',
  VIEW_SIGNALS: 'view_signals',
} as const;

export type Permission = (typeof PERMISSIONS)[keyof typeof PERMISSIONS];
